import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ChevronBasPictoProps extends pictoProps {
}

export interface ChevronBasPictoState extends pictoState {
}

export class ChevronBasPicto extends Picto<ChevronBasPictoProps,ChevronBasPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.chevronBasPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ChevronBasPicto);
